import React from "react";
import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { isKeyPressed } from "../../../utils/isKeyPressed";
import { RETURN_KEY_CODE, SPACEBAR_KEY_CODE } from "../../../utils/Browser/keyCodes";
import { jsx as _jsx } from "react/jsx-runtime";
const TableRow = _ref => {
  let {
    id = "",
    className = "",
    clickable = true,
    children = [],
    secondaryDataList = [],
    style = {},
    hoverable = true,
    dataTestId = "",
    onCellClick = null,
    rowIndex = 0,
    parent = ""
  } = _ref;
  const handleCellClick = (columnIndex, event) => {
    if (parent === "table-body" && isFunction(onCellClick)) {
      onCellClick(rowIndex, columnIndex, event);
    }
  };
  const tableRowClass = cn("border-b border-solid border-light-border-blue text-left app-components-table-row", {
    "cursor-pointer": clickable,
    "hover:bg-medium-fill-blue app-components-table-row--hoverable": hoverable && parent === "table-body"
  }, className);
  const filteredChildren = filterChildren(children);
  const childrenWithFuncs = React.Children.map(filteredChildren, (child, index) => /*#__PURE__*/React.cloneElement(child, {
    onCellClick: handleCellClick,
    columnIndex: index,
    secondaryDataList
  }));
  const role = onCellClick ? "button" : "row";
  const handleKeyDown = event => {
    if (isFunction(onCellClick) && clickable && (isKeyPressed(event, "Enter", RETURN_KEY_CODE) || isKeyPressed(event, " ", SPACEBAR_KEY_CODE))) {
      onCellClick(rowIndex, null, event);
    }
  };
  return /*#__PURE__*/_jsx("tr", {
    id: id,
    className: tableRowClass,
    onClick: e => handleCellClick(null, e),
    onKeyDown: handleKeyDown,
    style: style,
    role: role,
    tabIndex: 0,
    "data-testid": dataTestId,
    children: childrenWithFuncs
  });
};
TableRow.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** If true, row will be clickable */
  clickable: PropTypes.bool,
  /** If true, row will be hoverable */
  hoverable: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** children props for content inside */
  children: PropTypes.node,
  /** on cell click passed from the TableBody component */
  onCellClick: PropTypes.func,
  /** Row index passed from TableBody component */
  rowIndex: PropTypes.number.isRequired,
  /** Root parent component */
  parent: PropTypes.string,
  /** Data (in columns) to hide passed from TableHead or TableBody component */
  secondaryDataList: PropTypes.array,
  /** Immutable identifier for testing */
  dataTestId: PropTypes.string
};
export default TableRow;
//# sourceMappingURL=TableRow.js.map